import { render, staticRenderFns } from "./quest.vue?vue&type=template&id=1477d701"
import script from "./quest.vue?vue&type=script&lang=js"
export * from "./quest.vue?vue&type=script&lang=js"
import style0 from "./quest.vue?vue&type=style&index=0&id=1477d701&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports